<template>
  <select v-model="selectedFarm" @change="farmChanged" class="form-control rounded-0 mb-25">
    <option v-for="farm in farms" :value="farm" v-bind:key="farm.Id">{{ farm.farmShortname }}</option>
  </select>
</template>

<script>
import {onMounted, ref} from "vue";
import VisitorSigninService from "../../services/visitorsigninservice";

export default {
  name: "farms",
  props: {},
  emit: ["farmChanged"],
  setup() {
    const visitorSigninService = VisitorSigninService;

    const selectedFarm = ref();
    const farms = ref([]);

    const setupFarms = async () => {

      let results = await visitorSigninService.fetchFarms();

      results.sort((a, b) => a.farmShortname.localeCompare(b.farmShortname));

      farms.value = results;
    };

    onMounted(setupFarms);

    return {
      selectedFarm,
      visitorSigninService: VisitorSigninService,
      farms
    };
  },
  methods: {
    farmChanged() {
      this.$emit("farmChanged", this.selectedFarm);
    }
  }
};
</script>